<template>
  <div class="tree-search">
    <div class="input-container">
      <ElInput
        ref="searchInput"
        v-model.trim="query"
        :placeholder="props.inputPlaceholder ?? 'Поиск по дереву'"
      >
        <template #prefix>
          <PsIcon name="search" />
        </template>
        <template #suffix>
          <PsIcon
            v-if="query.length > 0"
            name="close"
            style="cursor: pointer;"
            @click="query = ''"
          />
        </template>
      </ElInput>
    </div>
    <div
      ref="treeContainer"
      class="tree-container"
    >
      <Tree
        :items="filteredItems"
        :showExpanded="showExpanded"
      >
        <template #item="{ item }">
          <slot
            name="item"
            :item="item"
          />
        </template>
      </Tree>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, useTemplateRef, onMounted } from 'vue'
import { ElInput } from 'element-plus'
import Tree from './Tree.vue'
import PsIcon from '@/ContextTab/components/UI/PsIcon.vue'
import { search, textSearchCriteria } from './search'
import type { ITreeItem } from './search'


const props = defineProps<{
  items: ITreeItem[]
  showExpanded?: boolean
  expandOnSearch?: boolean
  inputPlaceholder?: string
}>()

const searchInput = useTemplateRef('searchInput')

const query = ref('')
const treeContainer = useTemplateRef<HTMLDivElement>('treeContainer')

const filteredItems = computed(() => {
  if (!query.value) {
    return props.items
  }

  const { tree } = search(
    props.items,
    textSearchCriteria(query.value, ['name', 'path']),
  )

  return tree
})

const showExpanded = computed(() =>
  props.showExpanded
  || (props.expandOnSearch && query.value.length >= 3),
)

function scrollToTop() {
  treeContainer.value?.scrollTo(0, 0)
}

onMounted(() => {
  searchInput.value?.focus()
})

defineExpose({
  scrollToTop,
})
</script>

<style scoped>
.tree-search {
  display: flex;
  flex-direction: column;

  .input-container {
    flex: 0 0 auto;
    margin-bottom: 12px;
  }

  .tree-container {
    flex-grow: 1;
    overflow-x: auto;
    overflow-y: auto;
  }
}
</style>
